import React, { Component, useState, useEffect } from 'react';
import {
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Row,
    Col,
    Button
} from "reactstrap";
import TableV from 'react-bootstrap/Table';
import Tab from 'react-bootstrap/Tab';
import { Table } from 'reactstrap';
import Nav from 'react-bootstrap/Nav';
import { unregister } from "../Interceptor.js";

import { isExpired, decodeToken } from "react-jwt";

var datos = {};

function PDF() {

    useEffect(() => {
        var token = localStorage.getItem('token');
        var isMyTokenExpired = isExpired(token);
        var token = localStorage.setItem("tokenValidate", isMyTokenExpired);
        console.log(isMyTokenExpired);
        if (isMyTokenExpired) {
            window.location = "/"
        }
        var ruta = localStorage.getItem("pdf");
        console.log(ruta);
        setPDF(ruta);
        var id = localStorage.getItem("Id_CFD");
        console.log(id);
        setId(id);
        var datosDoc = localStorage.getItem("datosDocumentos");
        console.log(JSON.parse(datosDoc));
        var Datos = JSON.parse(datosDoc);
        setComprobanteDatos(Datos);
        settipoComprobante(Datos.TipoComprobante);
        console.log(tipoComprobante);
       // login();
    }, []);


    const [comprobanteDatos, setComprobanteDatos] = React.useState(datos);
    const [id, setId] = React.useState("");
    const [rutaPdf, setPDF] = React.useState("");

    const [tipoComprobante, settipoComprobante] = React.useState("");

    const login = () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

       

        const apiUrl = './api/Documento/TraerDatosDocumentos';
        console.log(apiUrl);
        fetch(apiUrl, requestOptions)
            .then(response => response.json())
            .then(

                data => {
                    comprobantes = data.basePresentation;
                    console.log(data);
                    setComprobantesDatos([comprobantes]);
                }

            )
            .catch(error => {
                console.log('error', error);

            }
            )
    }

    const handleDescargarXML = () => {

        var token = localStorage.getItem('token');
        var isMyTokenExpired = isExpired(token);
        var token = localStorage.setItem("tokenValidate", isMyTokenExpired);
        console.log(isMyTokenExpired);
        if (isMyTokenExpired) {
            window.location = "/"
        }

        var id = localStorage.getItem("Id_CFD"); //3443269;
        var estadoDian = comprobanteDatos.EstadoDian;

        console.log(estadoDian);
        if (estadoDian === "EXITOSA" || estadoDian === "EXITOSA_NT") {

            var requestOptions = {
                method: 'GET',
                headers: new Headers(),
            }
            const apiUrl = './api/Documento/TraerXMLDocumento?iIdDocumento=' + String(id) + "&sEstadoDian=" + estadoDian;
            fetch(apiUrl, requestOptions)
                .then(response => response.json())
                .then(result => {

                    console.log(result);
                    var datos = result.basePresentation;
                    console.log(datos);
                    downloadBase64File(datos.Archivo, datos.NombreArchivo);
                })
                .catch(error => console.log('error', error));
        }
        else
            alert('No se posible descargar el XML debido a que el documento no se encuentra en estado EXITOSO en la Dian.')
    }

    function downloadBase64File(contentBase64, fileName) {
        const linkSource = `data:application/xml;base64,${contentBase64}`;
        const downloadLink = document.createElement('a');
        document.body.appendChild(downloadLink);

        downloadLink.href = linkSource;
        downloadLink.target = '_self';
        downloadLink.download = fileName;
        downloadLink.click();
    }

    return (
        <>
            <div className="content">
                
                
                <Row>
                    <Col md="8">
                        <Card>
                            <CardHeader>
                                <h3 className="title" style={{ fontFamily: 'Hammersmith One', marginLeft: "15px", marginTop: "10px" }}>Detalle del Comprobante</h3>
                            </CardHeader>
                            <h5 className="title" style={{ fontFamily: 'Hammersmith One', marginLeft: "30px", marginTop: "-10px" }}>{"Comprobante: " + id }</h5>
                            <object data={rutaPdf} type="application/pdf" width="100%" height="900px">
                            </object>
                        </Card>
                    </Col>
                    <Col md="4">
                        <Card>
                            <Tab.Container id="left-tabs-example" defaultActiveKey="first" style={{ margin: "10px", fontFamily: 'Hammersmith One' }}>

                                <Nav variant="tabs">
                                    <Nav.Item>
                                        <Nav.Link eventKey="first" style={{ fontFamily: 'Hammersmith One' }}>Detalles</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="second" style={{ fontFamily: 'Hammersmith One' }}>Acciones</Nav.Link>
                                    </Nav.Item>
                                </Nav>

                        <Tab.Content>
                                    <Tab.Pane eventKey="first" style={{ margin: "10px", fontFamily: 'Hammersmith One' }}>
                                        <h4 className="title" style={{ fontFamily: 'Hammersmith One', marginLeft: "5px", marginTop: "20px" }}>Detalles del Comprobante</h4>
                                        <Table >

                                    <tbody>
                                        <tr>
                                                    <td><b>Tipo Comprobante:</b></td>
                                                    <td>{tipoComprobante}</td>

                                        </tr>
                                        <tr>
                                            <td><b>Numero:</b></td>
                                                <td>{comprobanteDatos.Prefijo + comprobanteDatos.Numero}</td>

                                        </tr>
                                        <tr>
                                            <td><b>Nit Cliente:</b></td>
                                                <td>{comprobanteDatos.NitCliente}</td>

                                        </tr>
                                        <tr>
                                            <td><b>Nombre del Cliente:</b></td>
                                                <td>{comprobanteDatos.NombreCliente}</td>

                                        </tr>
                                        <tr>
                                            <td><b>Fecha Generacion:</b></td>
                                                <td>{comprobanteDatos.FechaGeneracion}</td>

                                        </tr>
                                        <tr>
                                            <td><b>Fecha Vencimiento:</b></td>
                                                <td>{comprobanteDatos.FechaVencimiento}</td>

                                        </tr>
                                        <tr>
                                            <td><b>Valor Total:</b></td>
                                                <td>{comprobanteDatos.ValorTotal}</td>

                                        </tr>
                                        <tr>
                                            <td><b>Estado DIAN:</b></td>
                                                <td>{comprobanteDatos.EstadoDian}</td>

                                        </tr>
                                    </tbody>
                                </Table>
                            </Tab.Pane>
                            <Tab.Pane eventKey="second">
                                <Button variant="contained"
                                    color="secondary"
                                            onClick={handleDescargarXML}
                                            style={{ margin: "20px" }}>
                                    Descargar XML
                                </Button>

                            </Tab.Pane>
                                </Tab.Content>
                            </Tab.Container>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
}

export default PDF;
